import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { UIService } from 'services';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-loader',
    template: require('./app-loader.component.html'),
    styles: [require('./app-loader.component.scss')],
    host: { class: ""},
})
export class AppLoaderComponent implements OnInit, OnDestroy {
    constructor(
        private uiService: UIService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {}

    public loadingState: boolean;
    private loadingStateSubscription: Subscription;

    ngOnInit(): void {

        this.loadingStateSubscription = this.uiService.loadingState$.subscribe(state => {
            this.loadingState = state;
            if (state === true) {
                this.renderer.addClass(this.document.body, 'loading');
            } else {
                this.renderer.removeClass(this.document.body, 'loading');
            }
        });
    }

    ngOnDestroy() {
        if (this.loadingStateSubscription) this.loadingStateSubscription.unsubscribe();
    }
}
